/* eslint-disable */
import { DISABILITY_CATEGORY_DETAILS, GET_CAST_CATEGORY, SET_RESERVATION_DETAILS_I, GET_REQUIRED_LANGUAGE_DROPDOWN_DATA, GET_TYPING_SHORTHAND_AND_TYPES_DROPDOWN_DATA, SET_SERVICE_ACCESS_RULES, SET_AGE_CRITERIA_DETAILS, SET_OTHER_DETAILS, SET_REQUISITION_REQUEST_FOR_APPROVAL, GET_PENDING_REQUISITION_DATA_DETAILS, GET_SENT_FOR_APPROVAL_REQUISITION_DATA_DETAILS, DELETE_REQUISITION_DATA_DETAILS, GET_PENDING_APPROVAL_DETAILS, ENTITY_APPROVAL, VIEW_REQUISITION_DOC } from "../../common/constants/endpoints";
import API from "../../helpers/API";
import { SET_ALL_REQUISITION_DISABILITY_CATEGORY_DROPDOWN, SET_CAST_CATEGORY_DETAILS, SET_REQUIRED_LANGUAGE_DROPDOWN_DATA, SET_TYPING_SHORTHAND_AND_TYPES_DROPDOWN_DATA, SET_JOB_NATURE_DETAILS, SET_REQUISITION_ID, SET_GET_PENDING_REQUISITION_DATA_DETAILS, SET_PENDING_REQUISITION_LIST_PAGE_NO_COUNTER, SET_GET_SENT_FOR_APPROVAL_REQUISITION_DATA_DETAILS, SET_SENT_FOR_APPROVAL_REQUISITION_LIST_PAGE_NO_COUNTER, SET_API_REQ_FLG, SET_PENDING_APPROVAL_DETAILS, SET_PENDING_APPROVAL_DETAILS_PAGE_NO_COUNTER } from '../../common/constants/ActionTypes';
import { toastr } from 'react-redux-toastr';
import { showLoader } from "../../common/actions/commonActions";
import FileDownload from "js-file-download";
import axios from "axios";

export const getRequisitionDisabilitiesDropDown = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(DISABILITY_CATEGORY_DETAILS, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_REQUISITION_DISABILITY_CATEGORY_DROPDOWN,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const getCastCategoryDetails = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_CAST_CATEGORY + `?module=profile_creation&type=caste_category`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_CAST_CATEGORY_DETAILS,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const addRequisitionDetailsI = (newRequisitionDetails) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader());
            response = await API.post(SET_RESERVATION_DETAILS_I, newRequisitionDetails, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_REQUISITION_ID,
                payload: response.data.requisitionFormDto.requisitionId,
            });
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getRequiredLanguageDropdownData = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_REQUIRED_LANGUAGE_DROPDOWN_DATA + `?module=requisition&type=required_languages`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_REQUIRED_LANGUAGE_DROPDOWN_DATA,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const getTypingShorthandAndTypesDropdownData = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_TYPING_SHORTHAND_AND_TYPES_DROPDOWN_DATA, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.data) {
                const typingAndShortHandTypesList = [
                    ...response.data.typingTypesList,
                    ...response.data.shortHandTypesList,
                ];
                response.data.typingAndShortHandTypesList = typingAndShortHandTypesList;
                dispatch({
                    type: SET_TYPING_SHORTHAND_AND_TYPES_DROPDOWN_DATA,
                    payload: response.data,
                });
            }

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const getJobNatureDetails = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_CAST_CATEGORY + `?module=profile_creation&type=job_nature`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_JOB_NATURE_DETAILS,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const setServiceAccessRulesDetails = (params, reqId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader());
            response = await API.post(SET_SERVICE_ACCESS_RULES + `?reqid=${reqId}`, params, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let apiRequestCmp = {
                serviceAccessRulesDetailsApiReq: true,
                criteriaApiReq: false,
                otherdetailsApiReq: false
            }
            if (response && response.data) {
                dispatch({
                    type: SET_API_REQ_FLG,
                    payload: apiRequestCmp,
                });
            };

            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const updateServiceAccessRulesDetails = (params, reqId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader());
            response = await API.patch(SET_SERVICE_ACCESS_RULES + `?reqid=${reqId}`, params, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let apiRequestCmp = {
                serviceAccessRulesDetailsApiReq: true,
                criteriaApiReq: false,
                otherdetailsApiReq: false
            }
            if (response && response.data) {
                dispatch({
                    type: SET_API_REQ_FLG,
                    payload: apiRequestCmp,
                });
            };

            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};
export const setAgeCriteriaDetails = (params, reqId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader());
            response = await API.post(SET_AGE_CRITERIA_DETAILS + `?reqid=${reqId}`, params, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let apiRequestCmp = {
                serviceAccessRulesDetailsApiReq: false,
                criteriaApiReq: true,
                otherdetailsApiReq: false
            }
            if (response && response.data) {
                dispatch({
                    type: SET_API_REQ_FLG,
                    payload: apiRequestCmp,
                });
            };
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const updateAgeCriteriaDetails = (params, reqId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader());
            response = await API.patch(SET_AGE_CRITERIA_DETAILS + `?reqid=${reqId}`, params, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let apiRequestCmp = {
                serviceAccessRulesDetailsApiReq: false,
                criteriaApiReq: true,
                otherdetailsApiReq: false
            }
            if (response && response.data) {
                dispatch({
                    type: SET_API_REQ_FLG,
                    payload: apiRequestCmp,
                });
            };
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};
export const setOtherDetails = (params, reqId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader());
            response = await API.post(SET_OTHER_DETAILS + `?reqid=${reqId}`, params, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.data) {
                dispatch(sendRequisitionDetailsForApproval(response.data))
            };
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const updateOtherDetails = (params, reqId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader());
            response = await API.patch(SET_OTHER_DETAILS + `?reqid=${reqId}`, params, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.data) {
                dispatch(sendRequisitionDetailsForApproval(response.data))
            };
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const sendRequisitionDetailsForApproval = (params) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader());
            response = await API.post(SET_REQUISITION_REQUEST_FOR_APPROVAL, params, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
            if (response && response.data) {
                window.location.reload()
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getPendingRequisitionDataDetails = (skipPage, limitPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let skip = Number(skipPage);
        let pageLimit = Number(limitPage);
        let response;
        try {
            response = await API.get(GET_PENDING_REQUISITION_DATA_DETAILS + `/${skip}` + `/${pageLimit}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_GET_PENDING_REQUISITION_DATA_DETAILS,
                payload: response.data,
            });
            dispatch({
                type: SET_PENDING_REQUISITION_LIST_PAGE_NO_COUNTER,
                payload: (skipPage * limitPage),
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getSentForApprovalRequisitionDataDetails = (skipPage, limitPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let skip = Number(skipPage);
        let pageLimit = Number(limitPage);
        let response;
        try {
            response = await API.get(GET_SENT_FOR_APPROVAL_REQUISITION_DATA_DETAILS + `/${skip}` + `/${pageLimit}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_GET_SENT_FOR_APPROVAL_REQUISITION_DATA_DETAILS,
                payload: response.data,
            });
            dispatch({
                type: SET_SENT_FOR_APPROVAL_REQUISITION_LIST_PAGE_NO_COUNTER,
                payload: (skipPage * limitPage),
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const deleteRequisitionRequest = (id) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;

        try {
            response = await API.patch(DELETE_REQUISITION_DATA_DETAILS + `?reqid=${id}`, {}, {
                headers: { 'Authorization': `Bearer ${token}` },
            });
            let successMessage = (response && response.data) ? response.data : response.message
            toastr.success(successMessage);
            dispatch(getPendingRequisitionDataDetails(0, 10))
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const updateRequisitionDetailsI = (newRequisitionDetails, id) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            dispatch(showLoader());
            response = await API.patch(SET_RESERVATION_DETAILS_I + `?reqid=${id}`, newRequisitionDetails, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_REQUISITION_ID,
                payload: response.data.requisitionFormDto.requisitionId,
            });
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getPendingApprovalRequisitionDataDetails = (skipPage, limitPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let skip = Number(skipPage);
        let pageLimit = Number(limitPage);
        let response;
        try {
            response = await API.get(GET_PENDING_APPROVAL_DETAILS + `/${skip}` + `/${pageLimit}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_PENDING_APPROVAL_DETAILS,
                payload: response.data,
            });
            dispatch({
                type: SET_PENDING_APPROVAL_DETAILS_PAGE_NO_COUNTER,
                payload: (skipPage * limitPage),
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const approvalEntityRequestForRequisition = (requestData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(ENTITY_APPROVAL, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
            if (response && response.data) {
                window.location.reload()
            }
        } catch (error) {

            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);

            return;
        }
    }
}

export const downloadDocumentsOfRequisition = (reqid, docname) => {
    return async () => {
        let response;
        try {
            const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            const token = session.jwtResponse && session.jwtResponse.token;
            let urlString = VIEW_REQUISITION_DOC + `?reqid=${reqid}` + `&docname=${docname}`
            response = await axios.request({
                url: urlString,
                method: "GET",
                responseType: "blob",
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            toastr.error("Document not available to download");
            return;
        }
        FileDownload(
            response.data,
            `${docname}.pdf`
        );
    };
};